'use client';

export { default } from './ListItemIcon';
export { default as listItemIconClasses } from './listItemIconClasses';
export * from './listItemIconClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/ListItemIcon/index.js
// module id = 245
// module chunks = 25